import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-projects",
  "use": "icon-menu-projects-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-projects\">\n<path d=\"M1.49996 14.2972H2.33329V3.76407C2.33329 3.22603 2.67758 2.74837 3.18801 2.57822L9.85471 0.355999C10.6641 0.0861906 11.5 0.688657 11.5 1.54185V14.2972H12.3333V6.78913C12.3333 6.5262 12.5739 6.32899 12.8317 6.38056L14.6617 6.74657C15.246 6.86341 15.6665 7.37641 15.6665 7.97232V14.2972H16.5C16.9602 14.2972 17.3333 14.6703 17.3333 15.1306C17.3333 15.5908 16.9602 15.9639 16.5 15.9639H1.49996C1.03973 15.9639 0.666626 15.5908 0.666626 15.1306C0.666626 14.6703 1.03973 14.2972 1.49996 14.2972Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-projects.svg
// module id = 6LIL
// module chunks = 262